"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const RowCell = ({
  align = 'left',
  mobileTitle,
  children,
  breakWord,
  pLeft,
  pRight,
  size,
  ellipsis,
  title,
  className
}) => {
  const justify = align === 'right' ? 'flex-end' : align;
  return (0, _jsxRuntime.jsx)(_styles.Wrapper, {
    className: `${className ? className + ' ' : ''}table-cell`,
    "data-title": mobileTitle ? mobileTitle + ':' : null,
    css: [mobileTitle && _styles.styles.beforeStyle(size), breakWord && _styles.styles.breakWord, pLeft && _styles.styles.paddingLeft(pLeft), pRight && _styles.styles.paddingRight(pRight), size && _styles.styles.setFontSize(size), ellipsis && _styles.styles.ellipsis, align === 'center' && _styles.styles.textcenter, process.env.NODE_ENV === "production" ? "" : ";label:RowCell;"],
    justify: justify,
    title: title,
    children: children
  });
};
var _default = exports.default = RowCell;